import { useTranslation } from 'react-i18next';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { AvatarFlower } from 'us-react-components/dist/AvatarFlower/AvatarFlower';
import { Button, ButtonType } from '../../../../Button';

type Props = {
  imageUrls: string[];
  navigateToSearchPage(bookingVerticalTypeId: number | undefined): void;
}

export const FavoritesNullState = ({ imageUrls, navigateToSearchPage }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className='h-fit flex flex-col space-y-4 space-x-4 md:flex-row'>
      <div className='flex flex-wrap w-[189px] h-[180px] rounded-2xl bg-neutral-200 place-content-center relative'>
        <FontAwesomeIcon
          icon={faUser}
          className='text-white w-28 h-28 m-4'
        />
        <FontAwesomeIcon
          icon={faHeart}
          className='text-bubblegum w-5 h-5 absolute bottom-0 left-0 m-2'
          stroke='white'
          strokeWidth='40'
        />
      </div>
      <div className='w-full !ml-1 md:!ml-3 md:w-80'>
        <span className='block font-bold mt-2'>{t('dashboard.widgets.favorites.nullStateTitle')}</span>
        <span className='block mt-2'>{t('dashboard.widgets.favorites.nullStateDescription')}</span>
        <Button
          buttonType={ButtonType.tertiary}
          className='mt-3'
          onClick={() : void => navigateToSearchPage(undefined)}
        >
          {t('dashboard.widgets.favorites.searchForCaregivers')}
          <FontAwesomeIcon icon={faAngleRight} className='pl-2 m-[-1px]' />
        </Button>
      </div>
      <div className='md:2/4'>
        <AvatarFlower imageUrls={imageUrls} />
      </div>
    </div>
  );
};
